




















































































































































































































































































import { Component, Ref, Vue } from 'vue-property-decorator'
import { CompanyAPI, PipelineAPI, PipelinePhaseAPI, ReferralAPI } from '@/api/backend-client'
import { RealworksAPI } from '@/api/client/realworks'
import { Pipeline } from '@/api/model/pipeline'
import { PipelinePhase } from '@/api/model/pipeline-phase'
import { ListItemClickEvent } from '@/components/ui/list/list-item/ListItem.vue'
import { PipelineCategories, PipelineCategory, PipelinePhaseCategories, PipelinePhaseCategory } from '@/api/types'
import { v4 as uuid } from 'uuid'
import { ListPlaceholderActionClickEvent } from '@/components/ui/list/list-item/ListPlaceholderItem.vue'
import { ListItemActionClickEvent } from '@/components/ui/list/list-item/ListItemAction.vue'
import { ReferralStats } from '@/api/model/referral-stats'

@Component
export default class Edit extends Vue {
    loadingPipelines: boolean = false
    loadingPhases: boolean = false

    @Ref('phase-container') readonly phaseContainerElement!: HTMLElement

    editablePipelineId: string = null
    editablePipelinePhaseId: string = null
    activePipelineId: string = null

    pipelines: Pipeline[] = []

    entryPhases: PipelinePhase[] = []
    approachPhases: PipelinePhase[] = []
    decisionPhases: PipelinePhase[] = []

    pipelinesInUse: string[] = []
    pipelinePhasesInUse: string[] = []

    pipelineReferralCount: ReferralStats = null
    showImportPipelinePhaseModal = false
    loading: boolean = false
    loadingAgendaTypes: boolean = false
    agendaTypes: string[] = []

    async mounted() {
        await this.loadPipelines()
        await this.loadAgendaTypes()
    }

    async loadPipelines() {
        this.loadingPipelines = true
        this.pipelines = await PipelineAPI.getAll({
            company: this.$currentCompany.resourceIdentifier,
        })
        this.pipelines.sort((a, b) => a.name.localeCompare(b.name))
        this.loadingPipelines = false
    }

    async loadAgendaTypes() {
        this.loadingAgendaTypes = true
        this.agendaTypes.push(...await RealworksAPI.getAgendatypes())
        this.loadingAgendaTypes = false
    }

    async reloadPipelinePhases(pipelineId: string) {
        const pipeline = this.fetchPipeline(pipelineId)

        pipeline.phases = await PipelinePhaseAPI.getAll({
            pipeline: pipeline.resourceIdentifier,
        })
    }

    async loadPhases() {
        this.loadingPhases = true

        const promises = [
            PipelinePhaseAPI.getAll({
                pipeline: this.activePipeline.resourceIdentifier,
                category: PipelinePhaseCategory.ENTRY,
            }),
            PipelinePhaseAPI.getAll({
                pipeline: this.activePipeline.resourceIdentifier,
                category: PipelinePhaseCategory.APPROACH,
            }),
            PipelinePhaseAPI.getAll({
                pipeline: this.activePipeline.resourceIdentifier,
                category: PipelinePhaseCategory.DECISION,
            }),
        ]

        const [entry, approach, decision, counts] = await Promise.all(promises)

        this.entryPhases = entry
        this.approachPhases = approach
        this.decisionPhases = decision

        this.activePipeline.phases = [...entry, ...approach, ...decision]

        this.pipelineReferralCount = await ReferralAPI.getCounts(
            null,
            null,
            null,
            null,
            null,
        )

        this.loadingPhases = false
    }

    async itemClicked(event: ListItemClickEvent<Pipeline>) {
        if (this.loadingPhases || this.loadingPipelines) {
            return
        }

        const clickedItem: Pipeline = this.pipelines.find(pipeline => pipeline.id === event.item.id)

        if (clickedItem.id !== this.activePipelineId) {
            this.activePipelineId = clickedItem.id
            await this.loadPhases()
        } else {
            this.activePipelineId = null
        }
    }

    fetchPipeline(itemId: string): Pipeline {
        return this.pipelines.find(pipeline => pipeline.id === itemId)
    }

    fetchPhase(itemId: string): PipelinePhase {
        return this.allPhases.find(phase => phase.id === itemId)
    }

    async actionPipelineClicked(event: ListItemActionClickEvent<Pipeline>) {
        const clickedItem: Pipeline = this.pipelines.find(pipeline => pipeline.id === event.item.id)

        if (clickedItem.id !== this.editablePipelineId) {
            this.editablePipelineId = clickedItem.id
            this.activePipelineId = clickedItem.id
            await this.loadPhases()
        }
    }

    actionPhaseClicked(event: ListItemActionClickEvent<PipelinePhase>) {
        const clickedItem: PipelinePhase = this.allPhases.find(pipelinePhase => pipelinePhase.id === event.item.id)

        if (clickedItem.id !== this.editablePipelinePhaseId) {
            this.editablePipelinePhaseId = clickedItem.id
        }
    }

    getPhasesForCategory(category: PipelinePhaseCategory): PipelinePhase[] {
        return this[`${category}Phases`]
    }

    async createPipeline() {
        const pipeline = new Pipeline(
            this.$currentCompany,
            [],
            [],
            null,
            uuid(),
            this.$t('pipeline.pipeline').toString() + ' ' + (this.pipelines.length + 1),
            PipelineCategory.SALE,
            false,
            [],
            null,
            [],
            null,
            new Date(),
            new Date(),
        )

        await PipelineAPI.create(pipeline)
        this.pipelines.push(pipeline)

        await this.$nextTick(() => {
            this.activePipelineId = pipeline.id
            this.editablePipelineId = pipeline.id
        })

        await this.loadPhases()
    }

    async createPhaseFromPlaceholder(phaseCategory: PipelinePhaseCategory, event: ListPlaceholderActionClickEvent) {
        this.loadingPhases = true

        const pipelinePhase = new PipelinePhase(
            this.activePipeline,
            uuid(),
            this.$t('pipeline-phase.pipeline-phase').toString() + ' ' + event.position,
            phaseCategory,
            '#000000',
            event.position,
            false,
            false,
            false,
            new Date(),
            new Date(),
        )

        await PipelinePhaseAPI.create(pipelinePhase)
        this[phaseCategory + 'Phases'].push(pipelinePhase)

        await this.reloadPipelinePhases(this.activePipelineId)

        this.loadingPhases = false
    }

    async createPhase() {
        this.loadingPhases = true

        const insertCategory = PipelinePhaseCategory.ENTRY
        const pipelinePhase = new PipelinePhase(
            this.activePipeline,
            uuid(),
            this.$t('pipeline-phase.pipeline-phase').toString() + ' ' + (this.allPhases.length + 1),
            insertCategory,
            '#000000',
            this.allPhases.filter(phase => phase.category === insertCategory).length + 1,
            false,
            false,
            false,
            new Date(),
            new Date(),
        )

        await PipelinePhaseAPI.create(pipelinePhase)
        this.entryPhases.push(pipelinePhase)
        this.editablePipelinePhaseId = pipelinePhase.id

        await this.reloadPipelinePhases(this.activePipelineId)
        this.loadingPhases = false
    }

    async removePipeline(pipeline: Pipeline) {
        try {
            await PipelineAPI.delete(pipeline.id)

            this.pipelines.splice(
                this.pipelines.findIndex(findPipeline => findPipeline.id === pipeline.id),
                1,
            )
        } catch (error) {
            if (error.response && error.response.status === 405) {
                this.pipelinesInUse.push(pipeline.id)
                return
            }
        }

        this.editablePipelineId = null
        this.activePipelineId = null
    }

    async savePipeline(pipeline: Pipeline) {
        await PipelineAPI.update(pipeline.id, pipeline)

        this.pipelines = this.pipelines.map(mappedPipeline => mappedPipeline.id !== pipeline.id ? mappedPipeline : pipeline)

        this.editablePipelineId = null
    }

    async phaseMoved(event, phaseCategory) {
        const item = this.fetchPhase(event.itemId)
        const fromCategory = item.category
        const toCategory = phaseCategory.name
        this.loadingPhases = true

        if (toCategory !== fromCategory) {
            item.category = phaseCategory.name

            await this.sortCategory(fromCategory)
            await this.saveCategory(fromCategory)
        }

        await this.saveCategory(toCategory)
        await this.reloadPipelinePhases(this.activePipelineId)
        this.loadingPhases = false
    }

    async saveCategory(category: PipelinePhaseCategory): Promise<void> {
        await Promise.all(
            this.getPhasesForCategory(category)
                .map(async phase => await this.savePipelinePhase(phase)))
    }

    async sortCategory(category: PipelinePhaseCategory): Promise<void> {
        const phases = this.getPhasesForCategory(category)
            .map((phase, index) => PipelinePhase.fromData({ ...phase, sort: index + 1 }))

        this.$set(this, `${category}Phases`, phases)
    }

    async removePipelinePhase(pipelinePhase: PipelinePhase) {
        this.loadingPhases = true

        try {
            await PipelinePhaseAPI.delete(pipelinePhase.id)

            this[pipelinePhase.category + 'Phases'].splice(
                this[pipelinePhase.category + 'Phases'].findIndex(findPipelinePhase => findPipelinePhase.id === pipelinePhase.id),
                1,
            )
        } catch (error) {
            if (error.response && error.response.status === 405) {
                this.pipelinePhasesInUse.push(pipelinePhase.id)
                this.loadingPhases = false
                return
            }
        }

        await this.reloadPipelinePhases(this.activePipelineId)

        this.loadingPhases = false
    }

    async savePipelinePhase(pipelinePhase: PipelinePhase) {
        this.loadingPhases = true
        await PipelinePhaseAPI.update(pipelinePhase.id, pipelinePhase)

        if (!this[pipelinePhase.category + 'Phases'].includes(pipelinePhase)) {
            await this.loadPhases()
        }

        this.editablePipelinePhaseId = null
        this.loadingPhases = false
    }

    pipelineHasRequiredPhases(pipelineId: string): boolean {
        if (!pipelineId) {
            return false
        }

        const pipeline = this.fetchPipeline(pipelineId)

        const entryPhasesConfigured = pipeline.phases.some(phase => phase.active && phase.category === PipelinePhaseCategory.ENTRY)
        const decisionPhasesConfigured = pipeline.phases.some(phase => phase.active && phase.category === PipelinePhaseCategory.DECISION)
        const approachPhasesConfigured = pipeline.phases.some(phase => phase.active && phase.category === PipelinePhaseCategory.APPROACH)
        return entryPhasesConfigured && decisionPhasesConfigured && approachPhasesConfigured
    }

    pipelineStatus(pipeline: Pipeline) {
        const array = [undefined, null, '']
        const activeString = this.$t('forms.pipeline-form.active').toString()
        const inactiveString = this.$t('forms.pipeline-form.inactive').toString()

        if (array.includes(pipeline.name) || !PipelineCategories.includes(pipeline.category) || !this.pipelineHasRequiredPhases(pipeline.id)) {
            return {
                label: this.$t('forms.pipeline-form.not-configured').toString(),
                color: 'orange',
                icon: 'IconWarning',
            }
        }

        return {
            label: pipeline.active ? activeString : inactiveString,
            color: pipeline.active ? 'green' : 'red',
            icon: 'IconDot',
        }
    }

    pipelinePhaseStatus(pipelinePhase: PipelinePhase) {
        const array = [undefined, null, '']
        const activeString = this.$t('forms.pipeline-phase-form.active').toString()
        const inactiveString = this.$t('forms.pipeline-phase-form.inactive').toString()

        if (array.includes(pipelinePhase.name) || !PipelinePhaseCategories.includes(pipelinePhase.category) || pipelinePhase.color === '#000000') {
            return {
                label: this.$t('forms.pipeline-phase-form.not-configured').toString(),
                color: 'orange',
                icon: 'IconWarning',
            }
        }

        return {
            label: pipelinePhase.active ? activeString : inactiveString,
            color: pipelinePhase.active ? 'green' : 'red',
            icon: 'IconDot',
        }
    }

    get phaseCategoryLists(): Array<{ name: PipelinePhaseCategory, items: PipelinePhase[], maxItems: number }> {
        return [...PipelinePhaseCategories].reverse().map(pipelinePhaseCategory => {
            return {
                name: pipelinePhaseCategory,
                items: this[pipelinePhaseCategory + 'Phases'],
                maxItems: 1,
            }
        }).reverse()
    }

    get allPhases(): PipelinePhase[] {
        return [
            ...this.entryPhases,
            ...this.approachPhases,
            ...this.decisionPhases,
        ]
    }

    get disabledColorsOptions(): string[] {
        return this.allPhases.map(item => item.color)
    }

    get separatorOrigin(): null | HTMLElement {
        if (!this.activePipelineId) {
            return null
        }

        return document.getElementById('pipeline-' + this.activePipelineId)
    }

    get hasPhases() {
        return this.allPhases.length > 0
    }

    get hasPipelineReferrals() {
        if (!this.pipelineReferralCount) {
            return
        }

        return this.pipelineReferralCount.countForPipeline(this.activePipeline.id)
    }

    get canImportPhases() {
        return this.activePipeline && !this.hasPipelineReferrals
    }

    get activePipeline(): Pipeline {
        return this.fetchPipeline(this.activePipelineId)
    }

    async save(): Promise<void> {
        try {
            this.$notify({
                type: 'success',
                text: this.$t('pipeline.allPhaseSaved').toString(),
            })
            this.loading = true
            await CompanyAPI.update(this.$currentCompany.id, this.$currentCompany)
        } finally {
            this.loading = false
        }
    }
}
